import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => {

  // toggle state disclaimer on/off
  const stateDisclaimerIsActive = false;

  return  (
    <SectionContainer
      id='annuities-underlying-fund-information-intro'
      moduleName='intro-module'
      moduleVariation='A'>
      <Row align='center'>
        <Col
          medium={10}
          large={8}>
          <Typography
            component='h1'
            nextElement='typography'
            align='center'>
            Underlying Fund Information &#8212; Annuities
          </Typography>
          <Typography nextElement='typography'>
            For the most current quarterly Performance Update, download the{' '}
            <Link
              id='annuities-underlying-fund-information-intro-link'
              variant='primaryDeemphasize'
              linkUrl='/assets/pdf/financial-reports/annuities-prospectus-and-reports/quarterly-performance-update.pdf'
              isInternalPdf>
              Select Variable Annuity quarterly performance update
            </Link>
            {stateDisclaimerIsActive && (
              // toggle state disclaimer on/off with stateDisclaimerIsActive variable - DO NOT REMOVE
              <Typography component='span'>
                {' '}(not currently approved for use in Mississippi and Oklahoma)
              </Typography>
            )}.
          </Typography>
          <Typography nextElement='typography'>
            To help you select the funds that meet your objectives, risk tolerance and time horizon, the Select Variable Annuity fund offerings are organized into style boxes. Style boxes can help show one portfolio&#39;s characteristics relative to other investments in the same asset class. <strong>Simply select the fund within the style box for more information.</strong>
          </Typography>
          <Typography nextElement='typography'>
            A Northwestern Mutual financial representative can help walk you through the selection process of your investment options for Select Variable Annuity. Contact a financial representative today for an appointment.
          </Typography>
          <Typography disableBottomPadding>
            <strong>
              You should carefully consider the investment objectives, risks, expenses and charges of the investment company before you invest. Your Northwestern Mutual Investment Services Registered Representative can provide you with a prospectus that will contain the information noted above, and other important information that you should read carefully before you invest or send money.
            </strong>
          </Typography>
        </Col>
      </Row>
    </SectionContainer>
  );
};

